























































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import FounderConsultService from '../../../services/founder-consult.service';
import { Pagination, PaginatedResponse } from '../../../common';
import { FounderConsultListDto, FounderConsultDto } from '@/dto';
import { SPACE_TYPE, FOUNDER_CONSULT } from '@/services/shared';

import { getStatusColor } from '../../../core/utils/status-color.util';

@Component({
  name: 'DashboardFounderConsultList',
})
export default class DashboardFounderConsultList extends BaseComponent {
  private founderConsultList: FounderConsultDto[] = [];
  private founderConsultListCount = null;
  private pagination = new Pagination();
  private founderConsultListDto = new FounderConsultListDto();
  private dataLoading = false;

  // get status color
  getStatusColor(status: FOUNDER_CONSULT) {
    return getStatusColor(status);
  }

  //TODO:  need to refactor base service
  getDashboardList() {
    this.dataLoading = true;
    this.pagination.limit = 5;
    this.founderConsultListDto.spaceTypeNo = SPACE_TYPE.SPACE_SHARE;
    FounderConsultService.findAll(
      this.founderConsultListDto,
      this.pagination,
    ).subscribe(res => {
      this.dataLoading = false;
      this.founderConsultList = res.data.items;
      this.founderConsultListCount = res.data.totalCount;
    });
  }

  findOne(consolutNo) {
    this.$router.push(`/founder-consult/${consolutNo}`);
  }

  mounted() {
    this.getDashboardList();
  }
}
